import { Routes, Route } from "react-router-dom";
import FlyerEditor from "./FlyerEditor";
import FlyerTypePicker, { FlyerType } from "./FlyerTypePicker";
import FlyerLocalePicker from "./FlyerLocalePicker";
import Nav from "./Nav";
import PhpTest from "./components/PhpTest";
import ErrorTest from "./components/ErrorTest";
import styled from "styled-components";
import StarSticker from "./flyerTypes/StarSticker";
import { useFlyerConfig } from "./util/useFlyerConfig";
import Brochure from "./flyerTypes/Brochure";
import JoinChallenge from "./challenge/JoinChallenge";
import RecoverChallenge from "./challenge/RecoverChallenge";
import EmailPromptChallenge from "./challenge/EmailPromptChallenge";
import EuroSticker from "./flyerTypes/EuroSticker";
import QuittingFacebook from "./pages/QuittingFacebook";
import About from "./pages/About";
import Challenge from "./pages/Challenge";

export default function App() {
  return (
    <>
      <Nav />

      <Main className="Main">
        <Routes>
          <Route path="/" element={<FlyerTypePicker />} />
          <Route path="/pick-language/:flyerType" element={<FlyerLocalePicker />} />
          <Route path="/editor/:flyerType/:flyerLocale" element={<EditorRouter />} />
          <Route path="/challenge/email-prompt" element={<EmailPromptChallenge />} />
          <Route path="/challenge/join/:cid" element={<JoinChallenge />} />
          <Route path="/challenge/join" element={<JoinChallenge />} />
          <Route path="/challenge/recover/:token" element={<RecoverChallenge />} />
          <Route path="/challenge/recover" element={<RecoverChallenge />} />
          <Route path="/challenge/:cid" element={<Challenge />} />
          <Route path="/challenge" element={<Challenge />} />
          <Route path="/about" element={<About />} />
          <Route path="/php-test" element={<PhpTest />} />
          <Route path="/error-test" element={<ErrorTest />} />
          <Route path="/quitting-facebook" element={<QuittingFacebook />} />
        </Routes>
      </Main>
    </>
  );
}

const EditorRouter = () => {
  const { flyerType } = useFlyerConfig();
  return (flyerType === FlyerType.STAR_STICKER)
    ? (<StarSticker />)
    : (flyerType === FlyerType.EURO_STICKER)
    ? (<EuroSticker />)
    : (flyerType === FlyerType.BROCHURE)
    ? (<Brochure />)
    : (<FlyerEditor />)
}

const Main = styled.main`
  width: 100%;
  height: calc(100vh - 55px);
  margin-top: 55px;
  overflow: auto;
  color: var(--text-color);
  background-color: var(--side-bg-color);
`;


